
export const ServicesSection = () => {
  const services = [
    {
      image: "/lovable-uploads/deb908a6-2ef2-4338-a8f1-da05acc688cc.png",
      title: "Weekend Retreats",
      description: "Yoga, meditation, breathwork, and mindfulness escapes — time offline, surrounded by nature.",
      rotation: "rotate-2"
    },
    {
      image: "/lovable-uploads/handpan-workshop.jpg",
      title: "City-based Workshops",
      description: "Cooking, breath, sound, movement, and hands-on activities – gatherings that nourish body and soul.",
      rotation: "-rotate-1"
    },
    {
      image: "/lovable-uploads/circles-night-campfire.jpg",
      title: "Women's & Men's Circles", 
      description: "Gatherings that create trust, encourage self-expression, and nurture meaningful bonds.",
      rotation: "rotate-1"
    },
    {
      image: "/lovable-uploads/family-forest-hike.jpg",
      title: "Family Experiences",
      description: "Workshops that nurture closeness, spark joy, and create screen-free time to simply be together.",
      rotation: "-rotate-2"
    },
    {
      image: "/lovable-uploads/d932943a-5695-4492-bea1-bfac552e12fb.png",
      title: "Seasonal Projects",
      description: "Cyclical events in tune with nature – slowing down in autumn, awakening in spring.",
      rotation: "rotate-3"
    },
    {
      image: "/lovable-uploads/company-workshops.jpg",
      title: "Workshops for Companies",
      description: "Retreats and programs for teams – digital detox, regeneration, team bonding, and leadership development.",
      rotation: "-rotate-1"
    }
  ];

  return (
    <section id="services" className="py-24 bg-background relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-32 right-20 w-40 h-40 rounded-full border border-accent animate-pulse delay-700"></div>
        <div className="absolute bottom-32 left-20 w-20 h-20 rounded-full border border-accent animate-pulse delay-300"></div>
      </div>

      <div className="max-w-6xl mx-auto px-6 relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-5xl md:text-6xl font-serif font-light mb-8 text-foreground leading-tight">
            Paths We Offer
          </h2>
          <div className="w-32 h-px bg-gradient-to-r from-transparent via-accent to-transparent mx-auto mb-6"></div>
          <p className="text-xl text-muted-foreground max-w-4xl mx-auto leading-relaxed">
            We create space for <span className="text-foreground font-semibold">individuals</span>, <span className="text-foreground font-semibold">families</span>, <span className="text-foreground font-semibold">friends</span>, and <span className="text-foreground font-semibold">business teams</span> to enjoy quality time together, away from the noise of everyday life.
            No deadlines, no screens — just the freedom to talk, laugh, and simply be. It’s a chance to slow down, reconnect, and enjoy each other’s company without distractions.
          </p>
        </div>

        <div className="relative">
          {/* Main service grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-12 px-4 relative z-10">
            {services.map((service, index) => (
              <div 
                key={index} 
                className={`group hover-scale ${service.rotation} hover:rotate-0 transition-all duration-500 hover:scale-105`}
                style={{ animationDelay: `${index * 150}ms` }}
              >
                {/* Polaroid Card */}
                <div className="bg-white p-4 shadow-2xl hover:shadow-3xl transition-all duration-300 transform hover:z-10 relative">
                  {/* Photo */}
                  <div className="aspect-square mb-4 overflow-hidden">
                    <img 
                      src={service.image} 
                      alt={service.title}
                      className="w-full h-full object-cover hover:scale-110 transition-transform duration-700"
                      loading="lazy"
                    />
                  </div>
                  
                  {/* Polaroid bottom section with text */}
                  <div className="text-center space-y-3 min-h-[120px] flex flex-col justify-center">
                    <h3 className="text-lg font-serif font-medium text-gray-800 leading-tight">
                      <span className="bg-lime-400/60 px-2 py-1 relative inline-block transform -rotate-1 hover:rotate-0 transition-transform duration-300 rounded-sm">
                        {service.title}
                      </span>
                    </h3>
                    <p className="text-sm text-gray-600 leading-relaxed px-2">
                      {service.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};